var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag is-warning"},[_c('icon',{attrs:{"icon":"times"}}),_c('span',[_vm._v("False Positive")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }